import React, { useEffect, useRef, useState } from "react";
import "./cartDrawer.css";

// "Added to your cart" message with a View cart button. AddToCart (paymentContext) fires
// "tns:cart-added" after a successful add_cart; it falls back to the old notification when this isn't mounted.
export default function CartToast({ count, drawerOpen, onView }) {
  const [show, setShow] = useState(false);
  const timer = useRef(null);
  const openRef = useRef(drawerOpen);
  openRef.current = drawerOpen;

  useEffect(() => {
    window.__tnsCartToast = true;
    const added = () => {
      if (openRef.current) return; // plan change / undo inside the open cart: no message needed
      setShow(true);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setShow(false), 6000);
    };
    window.addEventListener("tns:cart-added", added);
    return () => { window.__tnsCartToast = false; window.removeEventListener("tns:cart-added", added); clearTimeout(timer.current); };
  }, []);
  useEffect(() => { if (drawerOpen) setShow(false); }, [drawerOpen]);

  if (!show) return null;
  const n = Number(count) || 0;
  return (
    <div className="ct-toast" role="status" aria-live="polite">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12l5 5 9-10" /></svg>
      <span className="ct-text">Added to your cart{n > 1 ? <small>{n} items waiting</small> : null}</span>
      <button type="button" className="ct-view" onClick={() => { setShow(false); onView(); }}>View cart</button>
      <button type="button" className="ct-x" aria-label="Close" onClick={() => setShow(false)}>×</button>
    </div>
  );
}
